import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCase as updateCaseApi } from "./services/airtable";

export function useUpdateCase() {
  const queryClient = useQueryClient();

  const { mutateAsync: updateCase, isLoading: isUpdating } = useMutation({
    mutationFn: updateCaseApi,
    onSuccess: () => {
      queryClient.invalidateQueries("case");
    },
  });

  return { isUpdating, updateCase };
}
